var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'sorter-' + _vm.column},[(_vm.type == 'asc')?_c('i',{staticClass:"fa fa-sort-amount-asc",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-sort-amount-desc",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }